<script setup>
import { computed } from 'vue';
import FilterButton from 'dashboard/components/ui/Dropdown/DropdownButton.vue';
import FilterListDropdown from 'dashboard/components/ui/Dropdown/DropdownList.vue';

const props = defineProps({
  name: {
    type: String,
    required: true,
  },
  id: {
    type: [String, Number, null],
    default: null,
  },
  type: {
    type: String,
    required: true,
  },
  options: {
    type: Array,
    default: () => [],
  },
  activeFilterType: {
    type: String,
    default: '',
  },
  showMenu: {
    type: Boolean,
    default: false,
  },
  placeholder: {
    type: String,
    default: '',
  },
  enableSearch: {
    type: Boolean,
    default: false,
  },
  showClearFilter: {
    type: Boolean,
    default: true,
  },
  filled: {
    type: Boolean,
    default: false,
  },
  icon: {
    type: String,
    default: '',
  },
  menuAlign: {
    type: String,
    default: 'end',
    validator: value => ['start', 'end'].includes(value),
  },
});

const emit = defineEmits([
  'toggleDropdown',
  'removeFilter',
  'addFilter',
  'closeDropdown',
]);
const toggleDropdown = () => emit('toggleDropdown', props.type);
const removeFilter = () => emit('removeFilter', props.type);
const addFilter = item => emit('addFilter', item);
const closeDropdown = () => emit('closeDropdown');

const menuPositionClass = computed(() =>
  props.menuAlign === 'start'
    ? 'ltr:left-0 rtl:right-0 z-50'
    : 'left-0 md:left-auto md:right-0'
);
</script>

<template>
  <FilterButton
    :filled="filled"
    trailing-icon
    :icon="icon || 'i-lucide-chevron-down'"
    :button-text="name"
    @click="toggleDropdown"
  >
    <template v-if="showMenu && activeFilterType === type" #dropdown>
      <FilterListDropdown
        v-if="options"
        v-on-clickaway="closeDropdown"
        :show-clear-filter="showClearFilter"
        :list-items="options"
        :active-filter-id="id"
        :input-placeholder="placeholder"
        :enable-search="enableSearch"
        class="flex flex-col w-[240px] overflow-y-auto top-10"
        :class="[menuPositionClass]"
        @select="addFilter"
        @remove-filter="removeFilter"
      />
    </template>
  </FilterButton>
</template>
